module.exports = __webpack_public_path__ + "static/physicality-371fa148404441ddf1880f1c5a581970.png";